/**
 * Цветовые мапы для primary и secondary кнопок. Необходимы, так как мы хотим, чтобы наш компонент
 * кнопки мог работать с любым цветом, сохраняя общий паттерн изменения цвета при определенных состояниях.
 * Если у нас в дизайне появляется новый цвет кнопки, которого здесь нет, то добавляем цвет
 * и все состояния измения цвета сюда, а затем уже используем кнопку, просто передавая ей параметр color
 */
const primaryButtonColors = {
  primary: 'ui-button--primary ui-button--color-primary',
  red: 'ui-button--primary ui-button--color-red',
  green: 'ui-button--primary ui-button--color-green',
  white: 'ui-button--primary ui-button--color-white',
}

const secondaryButtonColors = {
  primary: 'ui-button--secondary ui-button--color-primary',
  red: 'ui-button--secondary ui-button--color-red',
  green: 'ui-button--secondary ui-button--color-green',
}

const thirdButtonColors = {
  primary:
    'bg-transparent text-black border border-black rounded-[20px] ' +
    'hover:bg-primary-100 focus-visible:ring-primary-400 active:bg-primary-200 ' +
    'md:active:bg-white md:hover:bg-white',
}

const defaultButtonColors = {
  white: 'ui-button--default ui-button--color-white',
}

export {
  primaryButtonColors,
  secondaryButtonColors,
  thirdButtonColors,
  defaultButtonColors,
}
